import PropTypes from 'prop-types';

import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/cart/cartCheckout.scss';

const CartCheckout = ({ itemCountVerbiage, taxVerbiage, cart, onCheckingOut, loading }, { marketplace, testId }) => {
  const { cart: { cartName, cartCodeVerbiage = 'Have a Gift Card, Gift Certificate or Coupon Code? Proceed to checkout to redeem it.' } } = marketplace;
  const { activeItemTotalQuantity, subtotal: { amount } } = cart;

  return (
    <div className={css.container} data-test-id={testId('cartCheckout')}>
      <button
        type="button"
        disabled={loading || !activeItemTotalQuantity}
        onClick={onCheckingOut}
        data-test-id={testId('proceedToCheckout')}>
        {loading ? 'Updating...' : 'Proceed to Checkout'}
      </button>

      <p>{cartCodeVerbiage}</p>

      <h3>{cartName} summary ({itemCountVerbiage})</h3>

      <dl className={css.subtotal}>
        <dt data-test-id={testId('subtotalLabel')}>Subtotal<span> ({itemCountVerbiage})</span></dt>
        <dd data-test-id={testId('subtotal')}>{toUSD(amount)}</dd>
      </dl>
      <span className={css.legal} dangerouslySetInnerHTML={{ __html: taxVerbiage }} data-test-id={testId('taxVerbiage')}/>
    </div>
  );
};

CartCheckout.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default CartCheckout;
